import React from 'react'
import { MappingsContainer } from 'src/components/Reusable/Mappings/Mappings.styles'
import { TabCard } from 'src/components/Reusable/Tabs/Tabs.styles'
import { EvidenceToControlMappingInfo } from '@trustero/trustero-api-web/lib/evidencemgmt/evidencemgmt_pb'
import { EvidenceControlMappingSuggestedControls } from 'src/pages/Evidence/mappings/EvidenceControlMappings'
import { IndexingEvidenceSpinner } from 'src/pages/Evidence/index/EvidenceIndexPage.components'

export const EvidenceControlMappingsBody = ({
  mapping,
  isPolling,
}: {
  mapping: EvidenceToControlMappingInfo
  isPolling: boolean
}): JSX.Element | null => {
  const evidence = mapping.getEvidence()
  if (!evidence) {
    return null
  }
  return (
    <TabCard>
      {isPolling && <IndexingEvidenceSpinner />}
      <MappingsContainer>
        <EvidenceControlMappingSuggestedControls
          mapping={mapping}
          evidence={evidence}
        />
      </MappingsContainer>
    </TabCard>
  )
}
